import { render, staticRenderFns } from "./AddressList.vue?vue&type=template&id=5c2f3494&"
import script from "./AddressList.vue?vue&type=script&lang=ts&"
export * from "./AddressList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports